<template>
  <div class="chart-switcher">
    <div class="body">
      <div
        class="line"
        :class="{ selected: modelValue === 'line' }"
        @click="handleClick('line')"
      ></div>
      <div
        class="bar"
        :class="{ selected: modelValue === 'bar' }"
        @click="handleClick('bar')"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';

const emits = defineEmits(['update:modelValue', 'change']),
  props = defineProps({
    // 使用 v-model 绑定选中的类型
    modelValue: {
      type: String,
      default: 'line',
      validator: (value) => ['line', 'bar'].includes(value)
    },
    // 组件名称（可选）
    name: {
      type: String,
      default: null
    }
  }),
  // 处理点击事件
  handleClick = (type) => {
    if (props.modelValue !== type) {
      emits('update:modelValue', type);
      emits('change', type);
    }
  };

// 如果需要监听外部值的变化，可以保留这个watch
watch(
  () => props.modelValue,
  (newVal) => {
    // 如果需要在这里处理值变化时的逻辑
    console.log('当前选中的图表类型:', newVal);
  }
);
</script>

<style lang="scss" scoped>
.chart-switcher {
  .body {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 5px;
    font-size: 15px;
    font-weight: bold;
    margin-right: 10px;

    // 通用图标样式
    .line,
    .bar {
      width: 24px;
      height: 24px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;
      border-radius: 4px;

      &:hover {
        opacity: 0.8;
        transform: scale(1.1);
      }
    }

    // 折线图图标 - 未选中状态
    .line {
      background-image: url('@/assets/line.png');

      // 折线图选中时的效果
      &.selected {
        border-color: #ff4747;
        // 使用滤镜将图标颜色变为红色
        filter: invert(45%) sepia(100%) saturate(1000%) hue-rotate(325deg)
          brightness(1.1) contrast(1);
      }
    }

    // 柱状图图标 - 未选中状态
    .bar {
      background-image: url('@/assets/bar.png');

      // 柱状图选中时的效果 - 使用更强的滤镜参数
      &.selected {
        border-color: #ff4747;
        // 使用更强的滤镜参数确保柱状图也变红
        filter: invert(50%) sepia(100%) saturate(1500%) hue-rotate(320deg)
          brightness(1.1) contrast(1.2);
      }
    }
  }
}
</style>
